// src/modules/config/components/MenuItemModal/SEOTab.tsx
import React from 'react';
import { Form, Input, Row, Col, Card, Alert } from 'antd';

const { TextArea } = Input;

interface SEOTabProps {
  form: any; // FormInstance
  siteBaseUrl?: string; // Передаем URL с backend
}

export const SEOTab: React.FC<SEOTabProps> = ({ form, siteBaseUrl = 'https://yoursite.com' }) => {
  
  return (
    <div>
      <Alert
        message="SEO оптимизация"
        description="Заполните метаданные для лучшего ранжирования в поисковых системах"
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      {/* SEO заголовки */}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="meta_title"
            label="SEO заголовок (русский)"
          >
            <Input 
              placeholder="Заголовок для поисковых систем" 
              showCount
              maxLength={60}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="meta_title_kz"
            label="SEO заголовок (казахский)"
          >
            <Input 
              placeholder="Заголовок для поисковых систем на казахском" 
              showCount
              maxLength={60}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="meta_title_en"
            label="SEO заголовок (английский)"
          >
            <Input 
              placeholder="SEO title in English" 
              showCount
              maxLength={60}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* SEO описания */}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="meta_description"
            label="SEO описание (русский)"
          >
            <TextArea 
              rows={4}
              placeholder="Краткое описание для поисковых систем" 
              showCount
              maxLength={160}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="meta_description_kz"
            label="SEO описание (казахский)"
          >
            <TextArea 
              rows={4}
              placeholder="Краткое описание для поисковых систем на казахском" 
              showCount
              maxLength={160}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="meta_description_en"
            label="SEO описание (английский)"
          >
            <TextArea 
              rows={4}
              placeholder="Brief description for search engines in English" 
              showCount
              maxLength={160}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* Предварительный просмотр */}
      <Card title="Предварительный просмотр в поисковой выдаче" size="small">
        <div style={{ 
          border: '1px solid #e8e8e8', 
          padding: '12px', 
          borderRadius: '4px',
          backgroundColor: '#fafafa'
        }}>
          <div style={{ color: '#1a0dab', fontSize: '18px', marginBottom: '4px' }}>
            {form.getFieldValue('meta_title') || form.getFieldValue('name') || 'Название блюда'}
          </div>
          <div style={{ color: '#006621', fontSize: '14px', marginBottom: '4px' }}>
            {siteBaseUrl}/product/{form.getFieldValue('slug') || 'product-slug'}/detail/
          </div>
          <div style={{ color: '#545454', fontSize: '13px', lineHeight: '1.4' }}>
            {form.getFieldValue('meta_description') || form.getFieldValue('description') || 'Описание блюда для поисковых систем...'}
          </div>
        </div>
      </Card>
    </div>
  );
};